import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import {AuwMasonry} from "EXT/auw_pages_meta/Resources/Private/Js/AuwMasonry";
import {AuwAjaxPager} from "EXT/auw_pages_meta/Resources/Private/Js/AuwAjaxPager";
import {AuwAjaxLoader} from "EXT/auw_pages_meta/Resources/Private/Js/AuwAjaxLoader";



export class AuwAjaxFilter extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    init(){
        this.targetPageCollector = $('#'+this.config.targetPageCollector);
        this.$el = this.targetPageCollector.find('.ajax-filter');
        this.filterLinks = this.$el.find('.filter-item');
        this.mobileToggle = this.$el.find('.mobile-filter-toggle');
        this.pagerContainer = this.targetPageCollector.find(".ajax-pager");
        this.loaderButton = this.targetPageCollector.find(".ajax-loader");
        this.isRequesting = false;
    }


    __PageReady(){
        this.init();
        this.bindEvents();
    }

    bindEvents(){
        if(this.filterLinks.length){
            this.filterLinks.on("click",this.filterItemClicked.bind(this));
        }

        if(this.mobileToggle.length){
            this.mobileToggle.on("click",this.mobileFilterToggleClicked.bind(this));
        }
    }

    mobileFilterToggleClicked(e){
        e.preventDefault();
        this.$el.find('.filter-container').slideToggle();
        this.$el.toggleClass('filter-toggle-clicked');
    }


    filterItemClicked(e){
        e.preventDefault();

        if(!this.isRequesting) {
            this.isRequesting = true;
            var clickedElement = $(e.currentTarget);
            clickedElement.addClass('filter-clicked');

            if (clickedElement.hasClass('filter-item__tag')) {
                if (clickedElement.hasClass('filter-remove')) {
                    this.config.filterTags.splice(this.config.filterTags.indexOf(clickedElement.data("ajax-filter-tag")), 1);
                } else {
                    this.config.filterTags.push(clickedElement.data("ajax-filter-tag"));
                }
            } else if (clickedElement.hasClass('filter-item__pageType')) {
                if (clickedElement.hasClass('filter-remove')) {
                    this.config.filterPageTypes.splice(this.config.filterPageTypes.indexOf(clickedElement.data("ajax-filter-page-type")), 1);
                } else {
                    this.config.filterPageTypes.push(clickedElement.data("ajax-filter-page-type"));
                }

            }

            var arg              = {};
            arg.requestParameter = {ajaxPage: 1, ajaxCid: this.config.targetCid};

            if (this.config.filterTags.length) {
                arg.requestParameter.ajaxFilterTags = JSON.stringify(this.config.filterTags);
            }

            if (this.config.filterPageTypes.length) {
                arg.requestParameter.ajaxFilterPageTypes = JSON.stringify(this.config.filterPageTypes);
            }

            this.ajaxRequest = $.ajax({
                                          type: "GET",
                                          url : this.config.ajaxUri,
                                          data: arg,
                                      })
                                .done(this.parseAnswer.bind(this))
                                .fail(console.error)
                                .always(this.requestFinished.bind(this));
        }
    }

    requestFinished(){
        this.isRequesting = false;
    }

    parseAnswer(data){
        this.targetPageCollector.replaceWith(data);
        this.init();
        this.bindEvents();
        //scrollen zu
        ScrollManager.scrollTo(this.targetPageCollector);
        //wenn es mit masonry war
        var elementWithMasonry = this.targetPageCollector.find('.with-masonry');
        if(elementWithMasonry.length){
            new AuwMasonry(elementWithMasonry);
        }

        //wenn es einen pager gibt
        if(this.pagerContainer){
            this.pagerContainer = this.targetPageCollector.find(".ajax-pager");
            new AuwAjaxPager(this.pagerContainer);
        }

        //oder einen Loader
        if(this.loaderButton){
            this.loaderButton = this.targetPageCollector.find(".ajax-loader");
            new AuwAjaxLoader(this.loaderButton);
        }

    }

}
